import React from 'react'
import DocumentTitle from 'react-document-title'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import Table from '_/shared/components/table'
import Filter from '_/shared/components/filter'
import { Row, Col, MenuItem, ButtonToolbar, DropdownButton } from 'react-bootstrap'
import { ButtonLink, MenuItemLink } from 'react-router-bootstrap'

/**
 * My records page
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class MyRecords extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    records: React.PropTypes.object.isRequired
  }

  static contextTypes = {
    router: React.PropTypes.func
  }

  static fetchData (store, { query }) {
    return {
      records: store.get('/records', {
        ...query,
        limit: 15,
        isOwned: true
      })
    }
  }

  _renderAddNew() {
    const { account } = this.props

    return (
      <ButtonToolbar>
        <DropdownButton title="Add new&nbsp;" id="new-record-id" bsStyle="success">
          <MenuItemLink eventKey={1} to="new-record">
            <span className="text-success">Add new</span><br/>
            <small className="text-muted">Create a new record</small>
          </MenuItemLink>
          <MenuItemLink eventKey={2} to="import-records">
            <span className="text-info">Import records</span><br/>
            <small className="text-muted">Upload a CSV and map fields</small>
          </MenuItemLink>
          {!account.get('isAdmin') &&
            <MenuItem eventKey={3} href="/upload">
              <span className="text-warning">Upload files to us</span><br/>
              <small className="text-muted">Let us handle the dirty work</small>
            </MenuItem>
          }
        </DropdownButton>
        <ButtonLink to="text-search" query={{ myRecords: 1 }}>
          Search my records
        </ButtonLink>
      </ButtonToolbar>
    )
  }

  render() {
    const query = this.context.router.getCurrentQuery()

    return (
      <DocumentTitle title="My records">
        <div>
          <Row>
            <Col xs={5}>
              <h3 className="redi-table-header">My records</h3>
              {this._renderAddNew()}
            </Col>
            <Col xs={7}>
              <Filter
                {...query}
                route="my-records" />
            </Col>
          </Row>

          <Table
            {...query}
            route="my-records"
            limit={15}
            list={this.props.records}
            columns={[{
              name: 'id',
              viewRoute: 'record',
              format: 'photo',
              width: 80
            }, {
              name: 'address',
              label: 'Address',
              viewRoute: 'record',
              format: 'address',
              sortable: true,
              width: 300
            }, {
              name: 'city',
              label: 'City',
              sortable: true
            }, {
              name: 'pid',
              label: 'Parcel Id',
              sortable: true
            }, {
              name: 'genUseTM',
              label: 'General use',
              sortable: true,
              format: 'array'
            }, {
              name: 'gbaSf',
              label: 'GBA',
              sortable: true,
              format: 'number',
              width: 75
            }, {
              name: 'landSf',
              label: 'Land SF',
              sortable: true,
              format: 'number',
              width: 75
            }, {
              name: 'zoning',
              label: 'Zoning',
              sortable: true
            }]} />
        </div>
      </DocumentTitle>
    )
  }
}

export default MyRecords



// WEBPACK FOOTER //
// ./modules/shared/pages/record/myRecords.js